import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IMpxVodResponse } from '../../../entity/interface/iMpxVodResponse';
import { IMpxRepository } from '../../repositories/interfaces/IMpxRepository';

export interface IGetEpisodesUseCase {
    execute(byTvSeasonId: string, byCustomValue: string): Promise<IMpxVodResponse>;
}

export class GetEpisodesUseCase implements IGetEpisodesUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get mpxRepository(): IMpxRepository {
        return container.resolve<IMpxRepository>(DI.REPOSITORIES.IMpxRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(byTvSeasonId: string, byCustomValue: string): Promise<IMpxVodResponse> {
        return this.mpxRepository.getEpisodes(byTvSeasonId, byCustomValue);
    }
}
